






















































import {Component} from "vue-property-decorator"
import Vue from "vue"
import JdiContent from "@/components/JdiContent.vue"

import JdiHeading from "@/components/JdiHeading.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdsTimestamp from "@/design-system/components/Timestamp/JdsTimestamp.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsLocaleProvider from "@/design-system/foundation/JdsLocaleProvider.vue"
import JdiDoNot from "@/components/JdiDoNot.vue"
import JdsTerminology from "@/design-system/components/JdsTerminology.vue"
import JdiDocs from "@/components/JdiDocs.vue"

@Component({
    components: {
        JdiDocs,
        JdsTerminology,
        JdiDoNot, JdsLocaleProvider, JdiPreview, JdsTimestamp, JdsButton, JdiStatus, JdiHeading, JdiContent}
})
export default class Terminology extends Vue {
}
